import React from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import createReactClass from 'create-react-class'

const defaultGutter = 20

export const Row = createReactClass({
  displayName: 'Row',
  propTypes: {
    children: PropTypes.node.isRequired,
    className: PropTypes.string,
    gutter: PropTypes.number,
    style: PropTypes.object,
  },
  render() {
    let { gutter = defaultGutter } = this.props
    let rowStyle = {
      display: 'flex',
      flexWrap: 'wrap',
      msFlexWrap: 'wrap',
      WebkitFlexWrap: 'wrap',
      marginLeft: gutter / -2,
      marginRight: gutter / -2,
    }
    let className = classnames('Row', this.props.className)
    let props = this.props

    return (
      <div
        {...props}
        style={Object.assign(rowStyle, this.props.style)}
        className={className}
      />
    )
  },
})

export default Row
